var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"grey lighten-3 footer_app",attrs:{"fixed":"","padless":"","height":"45","light":""}},[_vm._t("left"),(!_vm.hideBackPage)?_c('v-spacer'):_vm._e(),(!_vm.hideTitle)?_c('span',[_vm._t("title")],2):_vm._e(),(!_vm.hideTitle)?_c('v-spacer'):_vm._e(),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }